import IcecastServer from "icecast-sdk-js";
import { useEffect, useState } from "react";
const REACT_APP_STREAM_ICECAST = process.env.REACT_APP_STREAM_ICECAST;

export const useIcecast = () => {
  const [stats, setStats] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const { host } = window.location;
  const radioName = host.split(".")[0];

  useEffect(() => {
    const fetchStats = async () => {
      try {
        setLoading(true);
        const ic = new IcecastServer(`https://${REACT_APP_STREAM_ICECAST}`);
        const statsData = await ic.getSource(radioName);
        setStats(statsData);
      } catch (err) {
        setError(err.message || "Error fetching stats");
      } finally {
        setLoading(false);
      }
    };

    const interval = setInterval(() => fetchStats(), 5000);
    return () => {
      clearInterval(interval);
    };
  }, []);
  return {
    icecastData: stats,
    icecastError: error,
    icecastLoading: loading,
    host,
  };
};
